export enum PRODUCT_TOUR_ELEMENT_CSS_SELECTORS {
  CLASSMATES = '#sidebar-item-classmates',
  HIGHLIGHTING = 'main p:first-of-type', // First paragraph of sequence
  FLASHCARDS = '#sidebar-item-revisions',
  FAQ = '#sidebar-item-faq',
  ACHIEVEMENTS_STEP_ZERO = '#sidebar-item-progression',
  ACHIEVEMENTS_STEP_ONE = '#achievements-card',
  ACHIEVEMENTS_STEP_TWO = '#achievement-tile-1',
  WALLET = '#wallet',
  FULL_SCREEN_LESSON = '#full-screen-lesson',
  LEARNING_RESOURCES_STEP_ONE = '#sidebar-item-learningResources',
  LEARNING_RESOURCES_STEP_TWO = 'div.tippy-content > div > div > div > ul > li:nth-child(3) > a',
}
